import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import CascoInsuranceContainer from './insuranceCards/casco/CascoInsuranceContainer';
import RCAInsuranceContainer from './insuranceCards/rca/RcaInsuranceContainer';
import RtiInsuranceContainer from './insuranceCards/rti/RtiInsuranceContainer';
import OfferType from 'constants/offerType';
import { useInsuranceTypeConfiguration } from 'utils/hooks/useInsuranceTypeConfiguration';
import { connect } from 'react-redux';

const InsuranceCard = ({ documentDetail, simulation, offerTypeId }) => {
  const insuranceTypeConfig = useInsuranceTypeConfiguration();

  const isOfferModification = useMemo(
    () => offerTypeId === OfferType.restructuring.id || offerTypeId === OfferType.cession.id,
    [offerTypeId]
  );

  return (
    <>
      {simulation.insuranceTypeCode === insuranceTypeConfig.rca?.propertyCode && (
        <Grid item xs={12}>
          <RCAInsuranceContainer simulation={simulation} documentDetail={documentDetail} />
        </Grid>
      )}
      {simulation.insuranceTypeCode === insuranceTypeConfig.casco?.propertyCode && (
        <>
          <Grid item xs={12}>
            <CascoInsuranceContainer documentDetail={documentDetail} simulation={simulation} offerTypeId={offerTypeId} />
          </Grid>
          {!isOfferModification && (
            <Grid item xs={12}>
              <RtiInsuranceContainer documentDetail={documentDetail} simulation={simulation} />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

InsuranceCard.propTypes = {
  documentDetail: PropTypes.object.isRequired,
  simulation: PropTypes.object.isRequired,
  offerTypeId: PropTypes.number.isRequired
};

function mapStateToProps(state) {
  const { offerTypeId } = state.currentOffer.header;
  return {
    offerTypeId
  };
}

export default connect(mapStateToProps)(InsuranceCard);
